import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastService } from '../toast/toast.service';

/**
 * `extensionAccepted` é uma lista separada por vírgula (".csv,.txt,.xlsx,.xls"),
 * no mesmo formato do atributo `accept` do input, que continua recebendo o valor.
 * CU-17tm466pyc5: antes a checagem era `includes` na string, sensível a maiúsculas
 * e por substring (".XLSX" era recusado e um arquivo "x.s" passava com ".csv").
 */
export function parseAcceptedExtensions(extensionAccepted: string): string[] {
  return (extensionAccepted ?? '')
    .split(',')
    .map(extension => extension.trim().toLowerCase())
    .filter(extension => extension.length > 0)
    .map(extension => (extension.startsWith('.') ? extension : `.${extension}`));
}

export function isExtensionAccepted(fileName: string, extensionAccepted: string): boolean {
  const accepted = parseAcceptedExtensions(extensionAccepted);
  if (accepted.length === 0) {
    return true;
  }

  const name = fileName ?? '';
  const dotIndex = name.lastIndexOf('.');
  if (dotIndex < 0) {
    return false;
  }

  return accepted.includes(name.slice(dotIndex).toLowerCase());
}

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss']
})
export class FileComponent implements OnInit {

  file: File;

  @Input()
  extensionAccepted: string

  @Input()
  class: string;

  @Output()
  fileSelected: EventEmitter<File> = new EventEmitter();

  constructor(
    private _toastService: ToastService
  ) { }

  ngOnInit(): void {}

  changeFile(event: Event): void {
    this.file = undefined;

    const inputFile = event.target as HTMLInputElement;
    const file = inputFile.files[0];

    if (this.extensionAccepted) {
      if (!isExtensionAccepted(file?.name, this.extensionAccepted)) {
        this._toastService.error('Arquivo inválido')!
        this.fileSelected.emit(undefined);
        return;
      }
    }

    this.file = file;
    this.fileSelected.emit(file);
  }

}
